import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import { getAllUsers, getUserById } from "../services/Users";
import UsersTable from "../components/PagesComponents/Users/UsersData/UsersTable";
import UsersDialogs from "../components/PagesComponents/Users/UsersData/UsersDialogs";
import UserActionsModal from "../components/PagesComponents/Users/UsersData/UserActionsModal";
import { useFeatures } from "../context/PermissionsAndFeatures/FeaturesContext";


const UsersManagement = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedUserForProfile, setSelectedUserForProfile] = useState(null);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserForRoots, setSelectedUserForRoots] = useState(null);
  const [selectedUserForBankPermissions, setSelectedUserForBankPermissions] =useState(null);
  const [selectedUserForModal, setSelectedUserForModal] = useState(null);
  const [selectedUserForEditDetails, setSelectedUserForEditDetails] =useState(null);

  const { features } = useFeatures();
  const usersLimit = Number(features?.users_number || 0);
  const isLimitReached = usersLimit > 0 && users.length >= usersLimit;


  const fetchUsers = async () => {
    setLoading(true);
    try {
      const data = await getAllUsers();
      setUsers(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleBankPermission = async (userId) => {
    try {
      const user = await getUserById(userId);
      setSelectedUserForBankPermissions(user);
    } catch (err) {
      alert("❌ فشل في تحميل بيانات المستخدم: " + err.message);
    }
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" gutterBottom>
        🔐 إدارة المستخدمين
      </Typography>

      {!isLimitReached ? (
        <Button
          variant="contained"
          color="primary"
          sx={{ my: 2 }}
          onClick={() => setOpenAddDialog(true)}
        >
          ➕ إضافة مستخدم جديد
        </Button>
      ) : (
        <Alert severity="warning" sx={{ my: 2 }}>
          ⚠️ لقد وصلت إلى الحد الأقصى لعدد المستخدمين المسموح به ({usersLimit} مستخدم)
        </Alert>
      )}

      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <UsersTable
          users={users}
          onEdit={setSelectedUser}
          onLinkRoots={setSelectedUserForRoots}
          onBankPermissions={handleBankPermission}
          onEditDetails={setSelectedUserForEditDetails}
          refresh={fetchUsers}
          onOpenActions={(user) => setSelectedUserForModal(user)} // ✅ لازم تضيف دي
        />
      )}

      <UsersDialogs
        openAddDialog={openAddDialog}
        onCloseAdd={() => setOpenAddDialog(false)}
        selectedUser={selectedUser}
        onCloseEdit={() => setSelectedUser(null)}
        selectedUserForRoots={selectedUserForRoots}
        onCloseRoots={() => setSelectedUserForRoots(null)}
        selectedUserForBankPermissions={selectedUserForBankPermissions}
        onCloseBankPermissions={() => setSelectedUserForBankPermissions(null)}
        refresh={fetchUsers}
        maxDialogHeight="90vh" // ✅ إضافة الارتفاع
      />
      
      <UserActionsModal
        user={selectedUserForModal}
        open={!!selectedUserForModal}
        onClose={() => setSelectedUserForModal(null)}
        onUpdated={fetchUsers}
      />
    </Box>
  );
};

export default UsersManagement;


